export default "__VITE_ASSET__3oQu$RS2__"